module.exports = __webpack_public_path__ + "static/product-acc-0050d10c7d98f33806c32ac19bdf1cb7.jpg";